import { AbstractBlockFactory } from '../block/AbstractBlockFactory';
import {
    AllowedMeasureFieldAggregations,
    BlockType,
    ComponentSettings,
    ComponentSettingsExternalVisualizationDataQueries,
    DatasetField,
    DatasetFieldValueType,
    IComponentProperties,
    NewBlockContextType,
    SimpleFormattingRule,
} from '@report-content';
import { AssocArray, YNValues } from 'tools/types';

export class BlockFactoryTextBlock extends AbstractBlockFactory<ComponentSettingsTextBlock> {
    public getNewBlock({
        nextUId,
        nextSortOrder,
        datasetFields,
    }: NewBlockContextType): BlockType<ComponentSettingsTextBlock> {
        const uid = 'block_uid_' + nextUId;
        return {
            // TODO:
            component: {
                datasetRendererBlockComponentId: nextUId,
                datasetRendererBlockId: nextUId,
                datasetRendererComponentId: nextUId,
                displayOrder: nextSortOrder,
                internalName: 'text_block',
                settings: {
                    dataQueries: {
                        table: {
                            resultFields: ['*'],
                            resultFieldAggregations: {},
                            limit: 1,
                        },
                    },
                    groupFilter: { operator: 'AND', rules: [] },
                    component_name: 'TextBlock',
                    uid: uid,
                    internal_name: 'text_block',
                    title: '',
                    height: 200,
                    measureFields: [],
                    formulaFields: [],
                    show_in_viewer: 'Y',
                    is_preview_ind: 'N',
                    include_in_email: 'Y',
                    // is_preview_ind: 'Y',
                    include_in_email_attachment: 'Y',
                    is_collapsed_ind: 'N',
                    report_no_units_label: 'No exceptions',
                    report_single_unit_label: 'exception',
                    report_multiple_units_label: 'exceptions',
                    isOnCreation: true,
                    html: '',
                },
            },
            // datasetRendererBlockId: number;
            displayOrder: nextSortOrder,
            // elementId: number;
            uid: uid,
        };
    }
}

interface ComponentSettingsTextBlockField {
    column_name: string;
    formattingRules?: Array<SimpleFormattingRule>;
    reference_name: string;
    value_type: DatasetFieldValueType;
}

export interface ComponentSettingsTextBlockMeasureField extends ComponentSettingsTextBlockField {
    aggregation_function: string;
    display_mask_id: string;
}

export interface ComponentSettingsTextBlockFormulaField extends ComponentSettingsTextBlockField {
    display_mask_id: string;
    expression: string;
    name: string;
}

export interface ComponentSettingsTextBlockDataQueries extends ComponentSettingsExternalVisualizationDataQueries {
    values?: {
        resultFields: Array<string>;
        resultFieldAggregations: any;
    };
    row_count?: {
        resultFields: Array<string>;
        return_count_only: YNValues;
        apply_display_masks_external: YNValues;
    };
    measurement_time?: boolean;
}

export interface ComponentSettingsTextBlock extends ComponentSettings {
    uid: string;
    component_name: 'TextBlock';
    html: string;
    outputHtml?: string;
    dataQueries: ComponentSettingsTextBlockDataQueries;
    measureFields: Array<ComponentSettingsTextBlockMeasureField>;
    formulaFields: Array<ComponentSettingsTextBlockFormulaField>;
    report_no_units_label: 'No exceptions';
    report_single_unit_label: 'exception';
    report_multiple_units_label: 'exceptions';
}

export function fieldToTextBlockMeasuredField(field: DatasetField): ComponentSettingsTextBlockMeasureField {
    const aggregations = AllowedMeasureFieldAggregations.filter((f) => f.value_type == field.value_type);

    return {
        aggregation_function: aggregations.length ? aggregations[0].name : '',
        column_name: field.column_name,
        reference_name: field.reference_name,
        value_type: field.value_type,
        formattingRules: [],
        display_mask_id: '',
    };
}

export interface TextBlockInitialDataResponse {
    dataResults: {
        measurement_time: [AssocArray<string | number>];
        row_count: [{ cnt: number }];
        table: [AssocArray<string | number>];
        values?: [AssocArray<string | number>];
    };
}

export interface AdditionalContentSettingsTextBlock extends IComponentProperties {
    validation: YNValues;
}
